

/// <reference path="AccountingJournalLineTemplate.ts" />

// Generated class AccountingJournalGroupTemplate_ManagedObject

class AccountingJournalGroupTemplate_ManagedObject extends AccountingJournalLineTemplate
{

    // Property: categoryType
    set categoryType(value:number) {
        this.setValueForKey(value, 'categoryType');
    }
    get categoryType():number {
        return this.valueForKey('categoryType');
    }
    set categoryTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'categoryType');
    }
    get categoryTypePrimitiveValue():number {
        return this.primitiveValueForKey('categoryType');
    }

    // Property: groupType
    set groupType(value:number) {
        this.setValueForKey(value, 'groupType');
    }
    get groupType():number {
        return this.valueForKey('groupType');
    }
    set groupTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'groupType');
    }
    get groupTypePrimitiveValue():number {
        return this.primitiveValueForKey('groupType');
    }

    // Property: isActive
    set isActive(value:boolean) {
        this.setValueForKey(value, 'isActive');
    }
    get isActive():boolean {
        return this.valueForKey('isActive');
    }
    set isActivePrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'isActive');
    }
    get isActivePrimitiveValue():boolean {
        return this.primitiveValueForKey('isActive');
    }

    // Property: lineMergeKey
    set lineMergeKey(value:string) {
        this.setValueForKey(value, 'lineMergeKey');
    }
    get lineMergeKey():string {
        return this.valueForKey('lineMergeKey');
    }
    set lineMergeKeyPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'lineMergeKey');
    }
    get lineMergeKeyPrimitiveValue():string {
        return this.primitiveValueForKey('lineMergeKey');
    }

    // Property: matchMode
    set matchMode(value:number) {
        this.setValueForKey(value, 'matchMode');
    }
    get matchMode():number {
        return this.valueForKey('matchMode');
    }
    set matchModePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'matchMode');
    }
    get matchModePrimitiveValue():number {
        return this.primitiveValueForKey('matchMode');
    }

    // Property: priority
    set priority(value:number) {
        this.setValueForKey(value, 'priority');
    }
    get priority():number {
        return this.valueForKey('priority');
    }
    set priorityPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'priority');
    }
    get priorityPrimitiveValue():number {
        return this.primitiveValueForKey('priority');
    }

    // Property: stopProcessing
    set stopProcessing(value:boolean) {
        this.setValueForKey(value, 'stopProcessing');
    }
    get stopProcessing():boolean {
        return this.valueForKey('stopProcessing');
    }
    set stopProcessingPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'stopProcessing');
    }
    get stopProcessingPrimitiveValue():boolean {
        return this.primitiveValueForKey('stopProcessing');
    }

    // Property: title
    set title(value:string) {
        this.setValueForKey(value, 'title');
    }
    get title():string {
        return this.valueForKey('title');
    }
    set titlePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'title');
    }
    get titlePrimitiveValue():string {
        return this.primitiveValueForKey('title');
    }
}
